module.exports = __webpack_public_path__ + "media/assets/images/category/Congrats@2x-cf973b20ea5e0cb0c93cb377e4040efe.png";